import security from '../../service/security/security-services';
import contractService from '../../service/contract/contract-services';
import {AUTH_EVENTS} from '../../service/security/security-module';
import server from '../../integration/server/server-services';
import {ILocationService, IRootScopeService, IScope} from "angular";
import {UserSession} from "../routes/contract-features-3/domain";

export default function topMenuController($rootScope: IRootScopeService, $scope: IScope, security: security,
                                          $location: ILocationService, contract: contractService, server: server) {
    const vm = this;

    vm.server = server;
    vm.$rootScope = $rootScope;
    vm.$location = $location;
    vm.contract = contract;
    vm.security = security;
    vm.showAdminMenuItem = false;

    vm.setContractDisplayName = setContractDisplayName;
    vm.getName = getName;
    vm.getPath = getPath;
    vm.logout = logout;
    vm.useUrl = useUrl;
    vm.changelogStatus = changelogStatus;
    vm.changelogLabel = changelogLabel;
    vm.registerChangelogEvent = registerChangelogEvent;

    refreshUser();

    $scope.$on(AUTH_EVENTS.AUTH_LOGGED_IN, () => {
        refreshUser();
    });

    function refreshUser() {
        vm.security.ensureCurrentUser()
            .then((user: UserSession) => {
                vm.showAdminMenuItem = user.hasPermissionInAnyScope('UI_ADMIN_HOME_PANE', 'VIEW');
                let equalNameAndUsername = user.name == user.username;
                vm.readableUserInfo = equalNameAndUsername ? user.name
                    : user.name + " (" + user.username + ")"; // Also display users username when it differs from users name
                vm.currentUser = user;
            })
    }

    function setContractDisplayName(name: string){
        const $rootScope = this.$rootScope;
        $rootScope.apply(function(){
            $rootScope.contractName = name;
        });
    }

    function getName(){
        const path = this.$location.path();

        if (path.indexOf('admin') != -1) {
            return 'ADMINISTRASJON';
        }

        if (path.indexOf('/contract/') != -1) {
            return this.contract.name;
        }

        return 'DATAFANGST';
    }
    function changelogStatus() {
        return "changelog_" + vm.currentUser?.changelogStatus ?? "none";
    }

    // Used to set status for screen readers, as they can't see the icon animation
    function changelogLabel() {
        return vm.currentUser?.changelogStatus ? "Endringslogg, ny versjon" : "Endringslogg, ingen nye endringer";
    }

    function registerChangelogEvent(event: MouseEvent){
        // Setter eventen på pause for å registrere at brukeren har klikket på pakken
        event.preventDefault();
        vm.server.registerReviewChangelogEvent(vm.currentUser)
            .then(() => {
                window.location.href = "/noauth/#!/changelog";
            });
    }

    function useUrl() {
        const path = this.$location.path();
        return (path.indexOf('admin') != -1) || (path.indexOf('/contract/') != -1);
    }

    function getPath() {
        const path = this.$location.path();

        if (path.indexOf('admin') != -1) {
            return '#!/admin';
        }

        if (path.indexOf('/contract/') != -1) {
            return '#!/contract/' + this.contract.contractId;
        }

        return '#!/';
    }

    function logout() {
        this.security.logout();
    }
}
topMenuController.$inject = ['$rootScope', '$scope', 'security', '$location', 'contract', 'server'];
